var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_vm._v("Forgot the password?\n\t"),_c('span',{attrs:{"id":"resetPassSpan"},on:{"click":function($event){_vm.passResetDialog = true}}},[_vm._v("\n\t\tReset password here\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }